/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { ButtonComponent, ComponentButtonDiv, PaginationComponent } from '../footerTableAction/footerTableAction-style';
import TablePrimary from '../tablePrimary/tablePrimary';
import * as XLSX from 'xlsx';
import TableSecondaryCadastro from '../tableSecondaryCadastro/tableSecondaryCadastro';
import { TableCadastroProps } from '../../../types/componentables';
import { useApi } from '../../../hooks/userApi';
import { useState } from 'react';
import { FileProp } from './FileProp';
import { AllProp } from './AllProp';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import TableComponente, { TTableDetails } from '../TableComponente/TableComponente.component';
import BtnPesquisa from 'components/BtnPesquisa/BtnPesquisa';
import ModalDelete from 'components/ModalDelete/ModalDelete.component';
import ColumnFilterComponent from './columnFilter';
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
const api = useApi();

const ComponenteTables: React.FC<TableCadastroProps> = ({
  table,
  cadastro,
  page,
  pageTotal,
  handleChangePage,
  handleLike,
  path,
  allData,
  itemExclude,
  open,
  setOpen,
  selectedFilterColumns,
  handleFilterColumnsChange,
  showFilterButton = true,
}) => {
  const [active, setSalvar] = React.useState(false);
  const [arrResponse, setReponse] = useState<AllProp>();
  const [arrResponseFile, setReponseFile] = useState<FileProp>();
  const [data, setData] = useState('');
  const [exportFormat, setExportFormat] = React.useState('csv');
  const [selectedFile, setSelectedFile] = useState(null);
  const [arrCaracteristica, setCaracteristica] = useState('');
  const [produto, setProduto] = useState('');
  const [categorias, setCategorias] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
    clearLoading,
    setClearLoading,
  }: any = React.useContext(LoadingContext);

  if (window.location.pathname.split('/')[2] === 'produtos') {
    React.useEffect(() => {
      api
        .get('/categoria')
        .then((response) => setCategorias(response))
        .catch((err) => {
          console.error('ops! ocorreu um erro' + err);
        });
    }, []);
  }

  React.useEffect(() => {
    const arr = arrResponseFile;
    if (arr) {
      if (arr.status) {
        const arrAux = JSON.parse(arrCaracteristica);
        arrAux.nome = JSON.parse(arrCaracteristica).nome;
        arrAux.hexadecimal = JSON.parse(arrCaracteristica).hexadecimal;
        arrAux.fotos = [{ id: arr.mensagem.foto.id }];

        if (arrAux) {
          setCaracteristica(JSON.stringify(arrAux));
          ApiRequest('/caracteristica', arrAux);
        }
      }
    }
  }, [arrResponseFile]);

  React.useEffect(() => {
    const arrResp = arrResponse;

    if (arrCaracteristica && arrResp) {
      if (arrResp.status) {
        const aux = JSON.parse(produto);
        aux.caracteristicas = [{ id: arrResp.mensagem.id }];
        if (aux) {
          ApiRequestFinal('/produto', aux);
        }
      }
    }
  }, [arrResponse]);

  // const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
  //   setPage(value);
  // };

  function handleSalvar() {
    window.location.pathname.split('/')[2] === 'orcamento' ? window.open('/vendedor') : setSalvar(!active);
  }

  const childToParent = (childdata) => {
    setData(childdata);
  };

  function isValidPassword(password) {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  }

  async function handleSalvarForm(event: any) {
    if (event === 'vendedores') {
      const _comissao = document.getElementById('comissao') as HTMLInputElement;
      const _contato = document.getElementById('contato') as HTMLInputElement;
      const _documento = document.getElementById('documento') as HTMLInputElement;
      const _endereco = document.getElementById('endereco') as HTMLInputElement;
      const _nome = document.getElementById('nome') as HTMLInputElement;
      const _telefone = document.getElementById('telefone') as HTMLInputElement;
      const _tipoDocumento = document.getElementById('tipoDocumentoo') as HTMLInputElement;
      const _emailContato = document.getElementById('emailContato') as HTMLInputElement;
      const emailVendedor = document.getElementById('emailVendedor') as HTMLInputElement;
      const password = document.getElementById('passwordVendedor') as HTMLInputElement;
      if (
        _comissao.value === '' ||
        _contato.value === '' ||
        _documento.value === '' ||
        _endereco.value === '' ||
        _nome.value === '' ||
        _telefone.value === '' ||
        _tipoDocumento.value === '' ||
        emailVendedor.value === '' ||
        password.value === '' ||
        _emailContato.value === ''
      ) {
        // eslint-disable-next-line
        _comissao.value === ""
          ? (_comissao.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _contato.value === ""
          ? (_contato.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _documento.value === ""
          ? (_documento.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _endereco.value === ""
          ? (_endereco.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _telefone.value === ""
          ? (_telefone.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _telefone.value === ""
          ? (_telefone.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        emailVendedor.value === ""
          ? (emailVendedor.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        password.value === ""
          ? (password.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _emailContato.value === ""
          ? (_emailContato.style.border = '1px solid red')
          : '1px solid green';
      } else {
        if (!isValidPassword(password.value)) {
          alert(
            'A senha deve ter pelo menos 8 caracteres, contendo 1 letra maiúscula, 1 número e 1 caractere especial.',
          );
          return;
        } else {
          const arrReq = {
            comissao: Number(_comissao.value),
            contato: _contato.value,
            documento: _documento.value,
            endereco: _endereco.value,
            nome: _nome.value,
            telefone: _telefone.value,
            tipoDocumentoo: _tipoDocumento.value,
            emailContato: _emailContato.value,
          };

          ApiRequest('/vendedor', arrReq);
        }
      }
    }

    if (event === 'log') {
      const _comissao = document.getElementById('id') as HTMLInputElement;
      const _contato = document.getElementById('Contexto') as HTMLInputElement;
      const _documento = document.getElementById('documento') as HTMLInputElement;
      const _endereco = document.getElementById('endereco') as HTMLInputElement;
      const _nome = document.getElementById('nome') as HTMLInputElement;
      const _telefone = document.getElementById('telefone') as HTMLInputElement;
      const _tipoDocumento = document.getElementById('tipoDocumentoo') as HTMLInputElement;
      if (
        _comissao.value === '' ||
        _contato.value === '' ||
        _documento.value === '' ||
        _endereco.value === '' ||
        _nome.value === '' ||
        _telefone.value === '' ||
        _tipoDocumento.value === ''
      ) {
        // eslint-disable-next-line
        _comissao.value === ""
          ? (_comissao.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _contato.value === ""
          ? (_contato.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _documento.value === ""
          ? (_documento.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _endereco.value === ""
          ? (_endereco.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _telefone.value === ""
          ? (_telefone.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _tipoDocumento.value === ""
          ? (_tipoDocumento.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          comissao: Number(_comissao.value),
          contato: _contato.value,
          documento: _documento.value,
          endereco: _endereco.value,
          nome: _nome.value,
          telefone: _telefone.value,
          tipoDocumentoo: _tipoDocumento.value,
        };

        ApiRequest('/vendedor', arrReq);
      }
    }

    if (event === 'categoria') {
      const _nome = document.getElementById('nome') as HTMLInputElement;

      if (_nome.value === '') {
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          nome: _nome.value,
        };
        await ApiRequest('/categoria', arrReq);
      }
    }

    if (event === 'negociacao') {
      const _nome = document.getElementById('nome') as HTMLInputElement;

      if (_nome.value === '') {
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          nome: _nome.value,
        };
        await ApiRequest('/negociacao', arrReq);
      }
    }

    if (event === 'formaPagamento') {
      const _nome = document.getElementById('nome') as HTMLInputElement;

      if (_nome.value === '') {
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          nome: _nome.value,
        };
        await ApiRequest('/pagamento', arrReq);
      }
    }

    if (event === 'cor') {
      const _nome = document.getElementById('nome') as HTMLInputElement;
      const _hexadecimal = document.getElementById('hexadecimal') as HTMLInputElement;

      if (_nome.value === '' || _hexadecimal.value === '') {
        // eslint-disable-next-line
        _nome.value === "" ? (_nome.style.border = "1px solid red") : null;
        // _hexadecimal.value === ""
        //   ? (_hexadecimal.style.border = "1px solid red")
        //   : null;
      } else {
        const arrReq = {
          nome: _nome.value,
          hexadecimal: _hexadecimal.value,
        };
        await ApiRequest('/cor', arrReq);
      }
    }

    if (event === 'imposto') {
      const _sigla = document.getElementById('sigla') as HTMLInputElement;
      const _nome = document.getElementById('nome') as HTMLInputElement;
      const _consumo = document.getElementById('consumo') as HTMLInputElement;
      const _revenda = document.getElementById('revenda') as HTMLInputElement;
      const _contribuinte = document.getElementById('contribuinte') as HTMLInputElement;
      const _naoContribuinte = document.getElementById('naoContribuinte') as HTMLInputElement;

      if (
        _sigla.value === '' ||
        _nome.value === '' ||
        _consumo.value === '' ||
        _revenda.value === '' ||
        _contribuinte.value === '' ||
        _naoContribuinte.value === ''
      ) {
        // eslint-disable-next-line
        _sigla.value === ""
          ? (_sigla.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _consumo.value === ""
          ? (_consumo.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _revenda.value === ""
          ? (_revenda.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _contribuinte.value === ""
          ? (_contribuinte.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _naoContribuinte.value === ""
          ? (_naoContribuinte.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          sigla: _sigla.value,
          consumo: Number(_consumo.value),
          revenda: Number(_revenda.value),
          contribuinte: Number(_contribuinte.value),
          nome: _nome.value,
          naoContribuinte: Number(_naoContribuinte.value),
        };
        ApiRequest('/icms-partilha', arrReq);
      }
    }

    if (event === 'cliente') {
      const _nome = document.getElementById('nome') as HTMLInputElement;
      const _email = document.getElementById('email') as HTMLInputElement;
      const _cpfCNPJ = document.getElementById('cpfCNPJ') as HTMLInputElement;
      const _endereco = document.getElementById('endereco') as HTMLInputElement;
      const _telefone = document.getElementById('telefone') as HTMLInputElement;
      const _whatsapp = document.getElementById('whatsapp') as HTMLInputElement;
      const _documento = document.getElementById('documento') as HTMLInputElement;
      const _tipoDocumento = document.getElementById('tipoDocumento') as HTMLInputElement;
      const _razaoSocial = document.getElementById('razaoSocial') as HTMLInputElement;
      const _nomeFantasia = document.getElementById('nomeFantasia') as HTMLInputElement;
      const _estado = document.getElementById('estado') as HTMLInputElement;
      const _vendedor = document.getElementById('vendedor') as HTMLSelectElement;

      if (
        _nome.value === '' ||
        _email.value === '' ||
        _cpfCNPJ.value === '' ||
        _endereco.value === '' ||
        _telefone.value === '' ||
        _whatsapp.value === '' ||
        _documento.value === '' ||
        _tipoDocumento.value === '' ||
        _razaoSocial.value === '' ||
        _nomeFantasia.value === '' ||
        _estado.value === '' ||
        _vendedor.value === '' ||
        _vendedor.value === null ||
        _vendedor.value === undefined ||
        _vendedor.value === 'Selecione'
      ) {
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _email.value === ""
          ? (_email.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _cpfCNPJ.value === ""
          ? (_cpfCNPJ.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _endereco.value === ""
          ? (_endereco.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _whatsapp.value === ""
          ? (_whatsapp.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _documento.value === ""
          ? (_documento.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _tipoDocumento.value === ""
          ? (_tipoDocumento.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _razaoSocial.value === ""
          ? (_razaoSocial.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _nomeFantasia.value === ""
          ? (_nomeFantasia.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _estado.value === ""
          ? (_estado.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _vendedor.value === "" ||
        _vendedor.value === null ||
        _vendedor.value === undefined ||
        _vendedor.value === 'Selecione'
          ? (_vendedor.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          nome: _nome.value,
          email: _email.value,
          cpfCNPJ: _cpfCNPJ.value,
          endereco: _endereco.value,
          telefone: _telefone.value,
          whatsapp: _whatsapp.value,
          documento: _documento.value,
          tipoDocumento: _tipoDocumento.value,
          razaoSocial: _razaoSocial.value,
          nomeFantasia: _nomeFantasia.value,
          estado: _estado.value,
          vendedor: { id: _vendedor.value },
        };

        ApiRequest('/cliente', arrReq);
      }
    }

    if (event === 'produto') {
      const _nome = document.getElementById('nome') as HTMLInputElement;
      const _categoria = document.getElementById('categoria') as HTMLInputElement;
      const _precoBase = document.getElementById('precoBase') as HTMLInputElement;
      const _precoConsumo = document.getElementById('precoConsumo') as HTMLInputElement;
      const _isActive = document.getElementById('isActive') as HTMLInputElement;
      const _precoRevenda = document.getElementById('precoRevenda') as HTMLInputElement;
      const _ipi = document.getElementById('ipi') as HTMLInputElement;
      const _imposto = document.getElementById('imposto') as HTMLInputElement;
      const _frete = document.getElementById('frete') as HTMLInputElement;
      const _margin = document.getElementById('margin') as HTMLInputElement;
      const _altura = document.getElementById('altura') as HTMLInputElement;
      const _largura = document.getElementById('largura') as HTMLInputElement;
      const _profundidade = document.getElementById('profundidade') as HTMLInputElement;
      const _SKU = document.getElementById('SKU') as HTMLInputElement;
      const _NCM = document.getElementById('NCM') as HTMLInputElement;

      // let _nomeCaracteristica = document.getElementById(
      //   "nomeCaracteristica"
      // ) as HTMLInputElement;
      const _cores = document.getElementById('cores') as HTMLInputElement;

      const _image = document.getElementById('image') as HTMLInputElement;

      if (
        _nome.value === '' ||
        _categoria.value === '' ||
        _categoria.value === 'Selecione' ||
        _precoBase.value === '' ||
        _precoConsumo.value === '' ||
        _precoRevenda.value === '' ||
        _ipi.value === '' ||
        _imposto.value === '' ||
        _isActive.value === '' ||
        _frete.value === '' ||
        _margin.value === '' ||
        _altura.value === '' ||
        _largura.value === '' ||
        _profundidade.value === '' ||
        _SKU.value === '' ||
        _NCM.value === '' ||
        _cores.value === '' ||
        _image.files[0] === null ||
        _image.files[0] === undefined
      ) {
        // eslint-disable-next-line
        _nome.value === ""
          ? (_nome.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _categoria.value === "" || _categoria.value === "Selecione"
          ? (_categoria.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _precoBase.value === ""
          ? (_precoBase.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _precoConsumo.value === ""
          ? (_precoConsumo.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _precoRevenda.value === ""
          ? (_precoRevenda.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _ipi.value === ""
          ? (_ipi.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _imposto.value === ""
          ? (_imposto.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _frete.value === ""
          ? (_frete.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _margin.value === ""
          ? (_margin.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _altura.value === ""
          ? (_altura.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _largura.value === ""
          ? (_largura.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _profundidade.value === ""
          ? (_profundidade.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _SKU.value === ""
          ? (_SKU.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _NCM.value === ""
          ? (_NCM.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        // _nomeCaracteristica.value === ""
        //   ? (_nomeCaracteristica.style.border = "1px solid red")
        //   : "1px solid green";
        // eslint-disable-next-line
        _cores.value === ""
          ? (_cores.style.border = '1px solid red')
          : '1px solid green';
        // eslint-disable-next-line
        _image.files[0] === null || _image.files[0] === undefined
          ? (_image.style.border = '1px solid red')
          : '1px solid green';
      } else {
        const arrReq = {
          nome: _nome.value,
          categoria: _categoria.value,
          precoBase: Number(_precoBase.value),
          precoConsumo: Number(_precoConsumo.value),
          precoRevenda: Number(_precoRevenda.value),
          ipi: Number(_ipi.value),
          imposto: Number(_imposto.value),
          frete: Number(_frete.value),
          margin: Number(_margin.value),
          altura: Number(_altura.value),
          largura: Number(_largura.value),
          profundidade: Number(_profundidade.value),
          SKU: _SKU.value,
          NCM: _NCM.value,
          isActive: _isActive.value === 'on' ? true : false,
          caracteristicas: [],
        };

        const _arrCaracteristica = {
          cores: [{ id: _cores.value }],
          fotos: [],
        };
        setProduto(JSON.stringify(arrReq));
        setCaracteristica(JSON.stringify(_arrCaracteristica));

        const formData = new FormData();
        formData.append('image', _image.files[0]);

        const arrFile = {
          content_length: `${_image.files[0].size}`,
        };

        ApiRequestFile('/foto', formData, arrFile);
      }
    }
  }

  async function ApiRequest(path: any, arrReq: any) {
    setLoading(true);
    const msg = 'Cadastro Realizado!';
    await api
      .post(path, arrReq)
      .then(async (response) => {
        setReponse(response);
        if (window.location.pathname.split('/')[2] !== 'produtos') {
          if (path === '/vendedor') {
            const emailVendedor = document.getElementById('emailVendedor') as HTMLInputElement;
            const password = document.getElementById('passwordVendedor') as HTMLInputElement;
            const permission = document.getElementById('permissaoVendedor') as HTMLInputElement;
            const arrObj = {
              email: emailVendedor.value,
              password: password.value,
              vendedor: {
                email: response.mensagem.emailContato,
                id: response.mensagem.id,
              },
              permissions: permission.value === 'Selecione' ? ['Vendedor'] : [permission.value],
            };
            const responseUsuario = await api.post('/usuario', arrObj);
            if (responseUsuario) {
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              responseUsuario.email
                ? (setLoadingMensagem(msg), setLoadingBtn('OK'), window.location.reload())
                : (setLoadingMensagem('Erro. Verifique os campos informados'), setLoadingBtn('OK'));
            }
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            response.status ||
            window.location.pathname.split('/')[2] === 'clientes' ||
            window.location.pathname.split('/')[2] === 'cores'
              ? (setLoadingMensagem(msg), setLoadingBtn('OK'), window.location.reload())
              : response.mensagem.code === 'ER_DUP_ENTRY'
                ? (setLoadingMensagem('Já existe ou existiu um campo na tabela com esse dado!'), setLoadingBtn('OK'))
                : (setLoadingMensagem('Erro. Verifique os campos informados'), setLoadingBtn('OK'));
          }
        }
      })
      .catch((err) => {
        const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }

  async function ApiRequestFile(path: any, arrReq: any, headers: any) {
    const msg = 'Cadastro Realizado!';
    await api
      .file(path, arrReq, headers)
      .then((response) => {
        setReponseFile(response);
        if (window.location.pathname.split('/')[2] !== 'produtos') {
          setLoadingMensagem(msg);
          setLoadingBtn('OK');
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          // response.status ? window.location.reload() : null;
        }
      })
      .catch((err) => {
        const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }

  async function ApiRequestFinal(path: any, arrReq: any) {
    let msg = 'Cadastro Realizado!';
    await api
      .post(path, arrReq)
      .then((response) => {
        if (!response.status) {
          // setClearLoading();
          setLoadingMensagem(response?.mensagem || 'Desculpe, não foi possível fazer essa ação!');
          setLoadingBtn('OK');
        } else {
          setReponseFile(response);
          setClearLoading();
          setLoadingMensagem(msg);
          setLoadingBtn('OK');

          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          response.status ? window.location.reload() : null;
        }
      })
      .catch((err) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        err.response?.data?.message
          ? (msg = err.response?.data?.message[0])
          : (msg = 'Verifique os campos informados e tente novamente!');

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }

  const handleChangeSelect = (event: SelectChangeEvent<string[]>, child: ReactNode) => {
    setSelectedColumns(event.target.value as string[]);
  };

  const handleExportarXLS = () => {
    const dadosProdutos = allData.rows as TTableDetails[];

    const colunaMapeada: { [key: string]: string } = {};
    allData.header.forEach((coluna) => {
      colunaMapeada[coluna] = coluna;
    });

    const headerRow: any = {};
    allData.header.forEach((coluna) => {
      if (selectedColumns.includes(coluna)) {
        headerRow[colunaMapeada[coluna]] = colunaMapeada[coluna];
      }
    });

    const dadosParaExportar = dadosProdutos.map((row) => {
      const produtoExportacao: any = {};

      row.rowCell.forEach((cell, index) => {
        const colunaOriginal = allData.header[index] as string;
        const colunaDesejada = colunaMapeada[colunaOriginal];

        if (colunaDesejada && cell && cell.campo && selectedColumns.includes(colunaOriginal)) {
          produtoExportacao[colunaDesejada] = cell.campo;
        }
      });

      return produtoExportacao;
    });

    dadosParaExportar.unshift(headerRow);

    const ws = XLSX.utils.json_to_sheet(dadosParaExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Dados');

    XLSX.writeFile(wb, 'produtos.xlsx');
  };

  const handleExportarCSV = () => {
    const dadosProdutos = allData.rows as TTableDetails[];

    const colunaMapeada: { [key: string]: string } = {};
    allData.header.forEach((coluna) => {
      colunaMapeada[coluna] = coluna;
    });

    const headerRow: any = {};
    allData.header.forEach((coluna) => {
      if (selectedColumns.includes(coluna)) {
        headerRow[colunaMapeada[coluna]] = colunaMapeada[coluna];
      }
    });

    const dadosExportacao = dadosProdutos.map((row) => {
      const produtoExportacao: any = {};

      row.rowCell.forEach((cell, index) => {
        const colunaOriginal = allData.header[index] as string;
        const colunaDesejada = colunaMapeada[colunaOriginal];

        if (colunaDesejada && cell && cell.campo && selectedColumns.includes(colunaOriginal)) {
          let valor = cell.campo;
          if (typeof valor === 'string' && valor.includes(',')) {
            valor = valor.replace(/"/g, '""');
            valor = `"${valor}"`;
          }
          produtoExportacao[colunaDesejada] = valor;
        }
      });

      return produtoExportacao;
    });

    dadosExportacao.unshift(headerRow);

    const csvContent =
      'data:text/csv;charset=utf-8,' +
      dadosExportacao.map((linha) => selectedColumns.map((col) => linha[col] || '').join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);

    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'produtos.csv');
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handleFormatChange = (event) => {
    setExportFormat(event.target.value);
  };

  const handleFilterColumnsChangeWrapper = (event: SelectChangeEvent<string[]>, child: React.ReactNode) => {
    handleFilterColumnsChange(event, child);
  };

  const availableColumns =
    Array.isArray(table.header) && typeof table.header[0] === 'string'
      ? (table.header as string[]).filter(
          (name) =>
            typeof name === 'string' &&
            !['Imagem', 'Editar', 'Excluir', 'Duplicar', 'Baixar', 'Gerenciar'].includes(name),
        )
      : [];

  return (
    <Stack spacing={2}>
      {!active && (
        <>
          {handleLike && (
            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
              <BtnPesquisa handleLike={handleLike} />
              {showFilterButton && (
                <Box>
                  <ColumnFilterComponent
                    selectedColumns={selectedFilterColumns}
                    handleColumnChange={handleFilterColumnsChangeWrapper}
                    availableColumns={availableColumns}
                  />
                </Box>
              )}
            </div>
          )}
          <TableComponente
            table={table.header as string[]}
            data={table.rows as TTableDetails[]}
            selectedFilterColumns={selectedFilterColumns}
          />
        </>
      )}
      {active && <TableSecondaryCadastro cadastro={cadastro.cadastro} title={cadastro.title} select={categorias} />}

      {!active && data !== 'true' && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            p: 1,
            m: 1,
          }}
        >
          {pageTotal > 1 && (
            <>
              <div>
                Apresentando {page} de {pageTotal} resultados
              </div>
              <PaginationComponent count={pageTotal} page={page} onChange={handleChangePage} />
            </>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '40%' }}>
              <FormControl sx={{ margin: 1, width: '60%' }}>
                <InputLabel id="column-selector-label">Selecione Colunas</InputLabel>
                <Select
                  labelId="column-selector-label"
                  id="column-selector"
                  multiple
                  value={selectedColumns}
                  onChange={handleChangeSelect}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {table.header.map((column) => {
                    if (
                      column !== 'Editar' &&
                      column !== 'Excluir' &&
                      column !== 'Duplicar' &&
                      column !== 'Imagem' &&
                      column !== 'Gerenciar' &&
                      column !== 'Baixar'
                    ) {
                      return (
                        <MenuItem key={column} value={column}>
                          {column}
                        </MenuItem>
                      );
                    }
                    return null;
                  })}
                </Select>
              </FormControl>
              <FormControl sx={{ margin: 1, width: '40%' }}>
                <InputLabel id="export-format-label">Formato de Exportação</InputLabel>
                <Select
                  labelId="export-format-label"
                  id="export-format"
                  value={exportFormat}
                  label="Formato de Exportação"
                  onChange={handleFormatChange}
                >
                  <MenuItem value="csv">CSV</MenuItem>
                  <MenuItem value="xls">Excel (XLS)</MenuItem>
                </Select>
              </FormControl>
              <ButtonComponent
                onClick={() => {
                  if (exportFormat === 'csv') {
                    handleExportarCSV();
                  } else if (exportFormat === 'xls') {
                    handleExportarXLS();
                  }
                }}
              >
                Exportar
              </ButtonComponent>
            </div>
            <ComponentButtonDiv>
              {table.type !== 'log' && <ButtonComponent onClick={() => handleSalvar()}>+ Adicionar</ButtonComponent>}
            </ComponentButtonDiv>
          </div>
        </Box>
      )}
      {active && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            p: 1,
            m: 1,
          }}
        >
          <ComponentButtonDiv>
            <ButtonComponent secundary onClick={() => handleSalvar()}>
              Cancelar
            </ButtonComponent>
            <ButtonComponent onClick={() => handleSalvarForm(table.type)}>Salvar</ButtonComponent>
          </ComponentButtonDiv>
        </Box>
      )}
      <ModalDelete path={path} itemExclude={itemExclude} open={open} setOpen={setOpen} />
    </Stack>
  );
};
export default ComponenteTables;
